import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-text-image-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, NzIconModule, NzInputModule, NzButtonModule, NzModalModule],
  templateUrl: './text-image-modal.component.html',
  styleUrl: './text-image-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextImageModalComponent {
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  @Input() title = '';
  @Input() content = '';

  @Input() okText: string | undefined = undefined;
  @Output() okClick = new EventEmitter<void>();

  @Input() cancelText: string | undefined = undefined;
  @Output() cancelClick = new EventEmitter<void>();

  @Input() imageSrc = '';

  @Input() closable = true;

  onIsVisibleChange(event: boolean) {
    this.isVisible = event;
    this.isVisibleChange.emit(this.isVisible);
  }

  onOkClick() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
    this.okClick.emit();
  }

  onCancelClick() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
    this.cancelClick.emit();
  }
}
